export default __webpack_public_path__ + "static/media/rewardsby-logo.b568ab8f.svg";